/**
 * Filler columns absorb the width left over when the real columns cannot fill
 * the table. They are ordinary cells, so the header rule and any row rules run
 * across them and the table reads full-bleed however narrow its columns are.
 *
 * One trailing filler left-aligns the columns. `centerColumns` adds a leading
 * one as well, splitting the leftover evenly so the columns sit in the middle.
 */
export const FILLER_COLUMN_ID = "filler";
export const LEADING_FILLER_COLUMN_ID = "filler-start";

/**
 * How narrow the trailing filler gets when it is the table's last column, as a
 * CSS length. The last cell's padding rule lands on the filler, so this plus
 * the real column's own end padding keeps the table's edge inset (the page
 * gutter) once the filler collapses. Mirrors the edge and cell padding in
 * `ViewTable.module.scss`.
 */
export const TRAILING_FILLER_MIN_WIDTH =
    "max(0px, calc(var(--view-table-edge-padding-inline, var(--page-padding-inline)) - var(--view-table-cell-padding-inline, 12px)))";

export function isFillerColumn(columnId: string | undefined): boolean {
    return (
        columnId === FILLER_COLUMN_ID || columnId === LEADING_FILLER_COLUMN_ID
    );
}
